if($('.customReviews').length){
    const storageKey = 'storeRatingData-' + document.location.host;

    function generateStars(score) {
      const full = Math.floor(score);
      const half = score % 1 >= 0.5;
      let html = '';
  
      for (let i = 0; i < full; i++) {
        html += '<span class="star star-on"></span>';
      }
      if (half && full < 5) {
        html += '<span class="star star-half"></span>';
      }
      return html;
    }
    function renderRating(data) {

      // Ochrana proti neparsovanému JSON
      const d = typeof data === 'string' ? JSON.parse(data) : data;

      const average = parseFloat(d.averageScore) || 0;
      const count = d.count || 0;
      const ratings = d.ratings?.slice(0, 4) || [];    
      //console.log(d)
      const reviewHtml = ratings.map(r => `
        <div class="review-item">
          <div class="header">
            <div class="review-name">${r.fullName || 'Ověřený zákazník'}</div>
            <div class="review-stars"><span class="stars">${generateStars(parseFloat(r.score) || 0)}</span></div>
          </div>
          <div class="review-description">${r.description}</div>
        </div>
      `).join('');
      $('.customReviews .reviewsNumbers .topNumber').text(average.toFixed(1).replace(".", ",")),
      $('.customReviews .counter span').text(count),
      $('.customReviews .reviewsNumbers .stars').html(generateStars(parseFloat(average) || 0)),
      $('.customReviews .reviews .rigth').html(reviewHtml);
    }
    const stored = sessionStorage.getItem(storageKey);
    if (stored) {
      renderRating(JSON.parse(stored));
    } else {
      $.ajax({
        url: '/cache/hodnoceni-obchodu/?jsonFormat',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Store-Rating-Details': 'true'
        },
        success: function (response) {
          sessionStorage.setItem(storageKey, JSON.stringify(response));
          renderRating(response);
        },
        error: function (xhr, status, error) {
          console.error('Chyba při načítání hodnocení:', error);
        }
      });
    }
}

